import { urlReplace } from "helpers/url";
import Api from "./Api";

export default class ProcedureService {
	constructor(api) {
		this.api = api || new Api();
	}

	async getAll(params) {
		return this.api.get('/secure/procedures', params);
	}

	async getById(id, params) {
		return this.api.get(urlReplace('/secure/procedures/{id}', { id: id }), params);
	}

}